<template>
  <div class="TheSidebarHeader">
    <RouterLink
      class="TheSidebarHeader__logo-container"
      :to="{ name: 'NewChat' }"
    >
      <img
        class="TheSidebarHeader__logo"
        src="/images/logo/evergpt-logo.svg"
        height="24"
        :title="`${appVersion}`"
      />
    </RouterLink>

    <UITooltip>
      <template #trigger>
        <UIButton
          class="TheSidebarHeader__toggle-button"
          theme="tertiary"
          size="md"
          :isDisabled="isNotAuthorised"
          leadIcon="sidebarFlipRegular"
          @click="$emit('toggle')"
        />
      </template>

      <template #content>
        <TooltipContentKeyboardShortcut>
          <div>Close sidebar</div>
          <UIKeyboardKey
            :theme="'dark'"
            :macKeys="['cmd', 'shift', 'S']"
            :winKeys="['ctrl', 'shift', 'S']"
          />
        </TooltipContentKeyboardShortcut>
      </template>
    </UITooltip>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { UIButton, UIKeyboardKey, UITooltip } from '@foundever/ui-lib'
import { storeToRefs } from 'pinia'

import { useAppStore } from '@/store/app'

import packageJson from '../../../../../package-lock.json'
import TooltipContentKeyboardShortcut from '../../misc/TooltipContentKeyboardShortcut.vue'

const appVersion = computed(() => packageJson.version)
const { isNotAuthorisedPage: isNotAuthorised } = storeToRefs(useAppStore())
defineEmits(['toggle'])
</script>

<style scoped lang="scss">
.TheSidebarHeader {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  width: 100%;
  margin-bottom: var(---fds-global-space-xs);

  .TheSidebarHeader__logo-container {
    display: flex;
  }

  .TheSidebarHeader__toggle-button.UIButton {
    --text-color: var(--icon-tertiary, #747481);
  }
}
</style>

<style>
.TheSidebarHeader__icon-shortcut {
  text-align: center;
  color: var(--text-tertiary);
}
</style>
